import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  display: inline-block;\n  width: 100%;\n  cursor: default;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        color: ", ";\n        cursor: not-allowed;\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  border: none;\n  padding: 0;\n  margin: 0 8px;\n  background: none;\n  outline: none;\n  cursor: pointer;\n\n  ", " {\n    color: ", ";\n    vertical-align: baseline;\n\n    &:hover {\n      color: ", ";\n    }\n\n    ", "\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      && {\n        color: ", ";\n        background-color: ", ";\n        border-top: ", ";\n        border-right: ", ";\n        border-bottom: ", ";\n        border-left: ", ";\n        border-radius: ", ";\n        font-weight: 600;\n        cursor: default;\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  min-width: ", ";\n  font-size: ", ";\n  color: ", ";\n  background-color: ", ";\n  border-top: ", ";\n  border-right: ", ";\n  border-bottom: ", ";\n  border-left: ", ";\n  border-radius: ", ";\n  display: inline-block;\n  height: 30px;\n  line-height: 30px;\n  margin-right: 8px;\n  text-align: center;\n  vertical-align: middle;\n  outline: 0;\n  cursor: pointer;\n  user-select: none;\n\n  &:last-child {\n    margin-right: 0;\n  }\n\n  &:hover {\n    color: ", ";\n    background-color: ", ";\n    border-top: ", ";\n    border-right: ", ";\n    border-bottom: ", ";\n    border-left: ", ";\n    border-radius: ", ";\n  }\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: ", ";\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  list-style: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState, useEffect, useCallback } from 'react';
import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Icon } from '../icon/Icon';
import { range } from '../utils/range';
var StyledPagination = styled.ul(_templateObject(), themeGet('pagination.border.bottom'));
var PaginationItem = styled.li(_templateObject2(), themeGet('pagination.item.minWidth'), themeGet('pagination.item.fontSize'), themeGet('pagination.item.color'), themeGet('pagination.item.backgroundColor'), themeGet('pagination.item.border.top'), themeGet('pagination.item.border.right'), themeGet('pagination.item.border.bottom'), themeGet('pagination.item.border.left'), themeGet('pagination.item.borderRadius'), themeGet('pagination.item.hover.color'), themeGet('pagination.item.hover.backgroundColor'), themeGet('pagination.item.hover.border.top'), themeGet('pagination.item.hover.border.right'), themeGet('pagination.item.hover.border.bottom'), themeGet('pagination.item.hover.border.left'), themeGet('pagination.item.hover.borderRadius'), function (props) {
  return props.active && css(_templateObject3(), themeGet('pagination.item.selected.color'), themeGet('pagination.item.selected.backgroundColor'), themeGet('pagination.item.selected.border.top'), themeGet('pagination.item.selected.border.right'), themeGet('pagination.item.selected.border.bottom'), themeGet('pagination.item.selected.border.left'), themeGet('pagination.item.selected.borderRadius'));
});
var PaginationArrow = styled.button(_templateObject4(), Icon, themeGet('pagination.arrow.color'), function (props) {
  return props.disabled ? themeGet('pagination.arrow.disabled.color') : themeGet('pagination.item.hover.color');
}, function (props) {
  return props.disabled && css(_templateObject5(), themeGet('pagination.arrow.disabled.color'));
});
var More = styled.span(_templateObject6(), themeGet('pagination.more.color'));
export var Pagination = function Pagination(_ref) {
  var defaultCurrent = _ref.defaultCurrent,
      current = _ref.current,
      _ref$pageSize = _ref.pageSize,
      pageSize = _ref$pageSize === void 0 ? 20 : _ref$pageSize,
      _ref$total = _ref.total,
      total = _ref$total === void 0 ? 0 : _ref$total,
      onChange = _ref.onChange;
  var totalPages = Math.ceil(total / pageSize);

  var _useState = useState(current || defaultCurrent || 1),
      _useState2 = _slicedToArray(_useState, 2),
      currentPage = _useState2[0],
      setCurrentPage = _useState2[1];

  var onPageChange = useCallback(function (page) {
    if (onChange) {
      onChange(page);
    }

    if (!current) {
      setCurrentPage(page);
    }
  }, [onChange, current]);
  var goLastPage = useCallback(function () {
    onPageChange(totalPages);
  }, [onPageChange, totalPages]);
  var goFirstPage = useCallback(function () {
    onPageChange(1);
  }, [onPageChange]);
  var goPreviousPage = useCallback(function () {
    onPageChange(currentPage - 1);
  }, [onPageChange, currentPage]);
  var goNextPage = useCallback(function () {
    return onPageChange(currentPage + 1);
  }, [onPageChange, currentPage]);
  useEffect(function () {
    if (current && current !== currentPage) {
      setCurrentPage(current);
    }
  }, [current, setCurrentPage, currentPage]);
  /**
   * First Page and Last Page is always show.
   * showPages is an array of showing page exclude 1st and last page
   * so showPages min value is 2, max value is (totalPages - 1)
   *
   * ps. range(2, 6) => [2, 3, 4, 5], so the min value pass range is totalPages
   */

  var showPages = currentPage <= 4 // 前四頁，都顯示 2 ~ 5
  ? range(2, Math.min(totalPages, 6)) // totalPages 小於等於 5 就顯示 2 ~ (totalPages - 1)
  : currentPage >= totalPages - 3 // 最後四頁，都顯示 最後四頁, ex: 總頁數 30，若 current page 大於等於 26 就顯示 25 ~ 29
  ? range(Math.max(2, totalPages - 4), totalPages) : range(Math.max(2, currentPage - 1), Math.min(totalPages, currentPage + 2));
  return (
    /*#__PURE__*/
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    React.createElement(PaginationArrow, {
      disabled: currentPage <= 1,
      onClick: goPreviousPage
    },
    /*#__PURE__*/
    React.createElement(Icon, {
      name: "ARROW_LEFT"
    })),
    /*#__PURE__*/
    React.createElement(StyledPagination, null,
    /*#__PURE__*/
    React.createElement(PaginationItem, {
      active: currentPage === 1,
      onClick: goFirstPage
    }, "1"), showPages[0] >= 3 &&
    /*#__PURE__*/
    React.createElement(PaginationItem, null,
    /*#__PURE__*/
    React.createElement(More, null, "...")), showPages.map(function (item) {
      return (
        /*#__PURE__*/
        React.createElement(PaginationItem, {
          active: currentPage === item,
          key: "".concat(item, "-pagination"),
          onClick: function onClick() {
            onPageChange(item);
          }
        }, item)
      );
    }), showPages[showPages.length - 1] <= totalPages - 2 &&
    /*#__PURE__*/
    React.createElement(PaginationItem, null,
    /*#__PURE__*/
    React.createElement(More, null, "...")), totalPages !== 1 &&
    /*#__PURE__*/
    React.createElement(PaginationItem, {
      active: currentPage === totalPages,
      key: "1-pagination",
      onClick: goLastPage
    }, totalPages)),
    /*#__PURE__*/
    React.createElement(PaginationArrow, {
      disabled: currentPage >= totalPages,
      onClick: goNextPage
    },
    /*#__PURE__*/
    React.createElement(Icon, {
      name: "ARROW_RIGHT"
    })))
  );
};